import { baseApi } from "./baseApi";

export interface AnalyticsEvent {
  id: string;
  pageId: string;
  eventType: string;
  eventData: Record<string, any>;
  userAgent: string;
  country: string;
  createdAt: string;
  customer: {
    id: string;
    name: string;
    email: string;
    domain: string;
  };
  page: {
    id: string;
    title: string;
    slug: string;
    template: string;
  };
}

export interface AnalyticsPagination {
  hasMore: boolean;
  nextCursor?: string;
  count: number;
}

export interface AnalyticsResponse {
  data: AnalyticsEvent[];
  pagination: AnalyticsPagination;
}

export interface AnalyticsQueryParams {
  limit?: number;
  cursor?: string;
  pageId?: string;
  eventType?: string;
  startDate?: string;
  endDate?: string;
}

export const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnalytics: builder.query<AnalyticsResponse, AnalyticsQueryParams>({
      query: (params) => ({
        url: "/analytics",
        params: {
          limit: params.limit || 100,
          ...params,
        },
      }),
      transformResponse: (response: { success: boolean; data: AnalyticsEvent[]; pagination: AnalyticsPagination }) => ({
        data: response.data,
        pagination: response.pagination,
      }),
      providesTags: (result, error, params) => [
        { type: "Analytics", id: params.pageId || "LIST" },
      ],
    }),
  }),
});

export const {
  useGetAnalyticsQuery,
  useLazyGetAnalyticsQuery,
} = analyticsApi;